var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 176,
    viewBox: "0 0 176 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 76C0 73.7909 1.79086 72 4 72C6.20914 72 8 73.7909 8 76C8 78.2091 6.20914 80 4 80C1.79086 80 0 78.2091 0 76Z",
    fill: "#169E8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0C6.20914 0 8 1.79086 8 4C8 6.20914 6.20914 8 4 8C1.79086 8 0 6.20914 0 4Z",
    fill: "#169E8C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 76C24 73.7909 25.7909 72 28 72C30.2091 72 32 73.7909 32 76C32 78.2091 30.2091 80 28 80C25.7909 80 24 78.2091 24 76Z",
    fill: "#169E8C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 4C24 1.79086 25.7909 0 28 0C30.2091 0 32 1.79086 32 4C32 6.20914 30.2091 8 28 8C25.7909 8 24 6.20914 24 4Z",
    fill: "#169E8C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48 76C48 73.7909 49.7909 72 52 72C54.2091 72 56 73.7909 56 76C56 78.2091 54.2091 80 52 80C49.7909 80 48 78.2091 48 76Z",
    fill: "#169E8C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48 4C48 1.79086 49.7909 0 52 0C54.2091 0 56 1.79086 56 4C56 6.20914 54.2091 8 52 8C49.7909 8 48 6.20914 48 4Z",
    fill: "#169E8C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72 76C72 73.7909 73.7909 72 76 72C78.2091 72 80 73.7909 80 76C80 78.2091 78.2091 80 76 80C73.7909 80 72 78.2091 72 76Z",
    fill: "#169E8C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72 4C72 1.79086 73.7909 0 76 0C78.2091 0 80 1.79086 80 4C80 6.20914 78.2091 8 76 8C73.7909 8 72 6.20914 72 4Z",
    fill: "#169E8C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M96 76C96 73.7909 97.7909 72 100 72C102.209 72 104 73.7909 104 76C104 78.2091 102.209 80 100 80C97.7909 80 96 78.2091 96 76Z",
    fill: "#169E8C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M96 4C96 1.79086 97.7909 0 100 0C102.209 0 104 1.79086 104 4C104 6.20914 102.209 8 100 8C97.7909 8 96 6.20914 96 4Z",
    fill: "#169E8C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M120 76C120 73.7909 121.791 72 124 72C126.209 72 128 73.7909 128 76C128 78.2091 126.209 80 124 80C121.791 80 120 78.2091 120 76Z",
    fill: "#169E8C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M120 4C120 1.79086 121.791 0 124 0C126.209 0 128 1.79086 128 4C128 6.20914 126.209 8 124 8C121.791 8 120 6.20914 120 4Z",
    fill: "#169E8C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M144 76C144 73.7909 145.791 72 148 72C150.209 72 152 73.7909 152 76C152 78.2091 150.209 80 148 80C145.791 80 144 78.2091 144 76Z",
    fill: "#169E8C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M144 4C144 1.79086 145.791 0 148 0C150.209 0 152 1.79086 152 4C152 6.20914 150.209 8 148 8C145.791 8 144 6.20914 144 4Z",
    fill: "#169E8C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M168 76C168 73.7909 169.791 72 172 72C174.209 72 176 73.7909 176 76C176 78.2091 174.209 80 172 80C169.791 80 168 78.2091 168 76Z",
    fill: "#169E8C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M168 4C168 1.79086 169.791 0 172 0C174.209 0 176 1.79086 176 4C176 6.20914 174.209 8 172 8C169.791 8 168 6.20914 168 4Z",
    fill: "#169E8C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0 100C0 97.7909 1.79086 96 4 96C6.20914 96 8 97.7909 8 100C8 102.209 6.20914 104 4 104C1.79086 104 0 102.209 0 100Z",
    fill: "#169E8C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0 28C0 25.7909 1.79086 24 4 24C6.20914 24 8 25.7909 8 28C8 30.2091 6.20914 32 4 32C1.79086 32 0 30.2091 0 28Z",
    fill: "#169E8C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M24 100C24 97.7909 25.7909 96 28 96C30.2091 96 32 97.7909 32 100C32 102.209 30.2091 104 28 104C25.7909 104 24 102.209 24 100Z",
    fill: "#169E8C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M24 28C24 25.7909 25.7909 24 28 24C30.2091 24 32 25.7909 32 28C32 30.2091 30.2091 32 28 32C25.7909 32 24 30.2091 24 28Z",
    fill: "#169E8C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M48 100C48 97.7909 49.7909 96 52 96C54.2091 96 56 97.7909 56 100C56 102.209 54.2091 104 52 104C49.7909 104 48 102.209 48 100Z",
    fill: "#169E8C"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M48 28C48 25.7909 49.7909 24 52 24C54.2091 24 56 25.7909 56 28C56 30.2091 54.2091 32 52 32C49.7909 32 48 30.2091 48 28Z",
    fill: "#169E8C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M72 100C72 97.7909 73.7909 96 76 96C78.2091 96 80 97.7909 80 100C80 102.209 78.2091 104 76 104C73.7909 104 72 102.209 72 100Z",
    fill: "#169E8C"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M72 28C72 25.7909 73.7909 24 76 24C78.2091 24 80 25.7909 80 28C80 30.2091 78.2091 32 76 32C73.7909 32 72 30.2091 72 28Z",
    fill: "#169E8C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M96 100C96 97.7909 97.7909 96 100 96C102.209 96 104 97.7909 104 100C104 102.209 102.209 104 100 104C97.7909 104 96 102.209 96 100Z",
    fill: "#169E8C"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M96 28C96 25.7909 97.7909 24 100 24C102.209 24 104 25.7909 104 28C104 30.2091 102.209 32 100 32C97.7909 32 96 30.2091 96 28Z",
    fill: "#169E8C"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M120 100C120 97.7909 121.791 96 124 96C126.209 96 128 97.7909 128 100C128 102.209 126.209 104 124 104C121.791 104 120 102.209 120 100Z",
    fill: "#169E8C"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M120 28C120 25.7909 121.791 24 124 24C126.209 24 128 25.7909 128 28C128 30.2091 126.209 32 124 32C121.791 32 120 30.2091 120 28Z",
    fill: "#169E8C"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M144 100C144 97.7909 145.791 96 148 96C150.209 96 152 97.7909 152 100C152 102.209 150.209 104 148 104C145.791 104 144 102.209 144 100Z",
    fill: "#169E8C"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M144 28C144 25.7909 145.791 24 148 24C150.209 24 152 25.7909 152 28C152 30.2091 150.209 32 148 32C145.791 32 144 30.2091 144 28Z",
    fill: "#169E8C"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M168 100C168 97.7909 169.791 96 172 96C174.209 96 176 97.7909 176 100C176 102.209 174.209 104 172 104C169.791 104 168 102.209 168 100Z",
    fill: "#169E8C"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M168 28C168 25.7909 169.791 24 172 24C174.209 24 176 25.7909 176 28C176 30.2091 174.209 32 172 32C169.791 32 168 30.2091 168 28Z",
    fill: "#169E8C"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M0 124C0 121.791 1.79086 120 4 120C6.20914 120 8 121.791 8 124C8 126.209 6.20914 128 4 128C1.79086 128 0 126.209 0 124Z",
    fill: "#169E8C"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M0 52C0 49.7909 1.79086 48 4 48C6.20914 48 8 49.7909 8 52C8 54.2091 6.20914 56 4 56C1.79086 56 0 54.2091 0 52Z",
    fill: "#169E8C"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M24 124C24 121.791 25.7909 120 28 120C30.2091 120 32 121.791 32 124C32 126.209 30.2091 128 28 128C25.7909 128 24 126.209 24 124Z",
    fill: "#169E8C"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M24 52C24 49.7909 25.7909 48 28 48C30.2091 48 32 49.7909 32 52C32 54.2091 30.2091 56 28 56C25.7909 56 24 54.2091 24 52Z",
    fill: "#169E8C"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M48 124C48 121.791 49.7909 120 52 120C54.2091 120 56 121.791 56 124C56 126.209 54.2091 128 52 128C49.7909 128 48 126.209 48 124Z",
    fill: "#169E8C"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M48 52C48 49.7909 49.7909 48 52 48C54.2091 48 56 49.7909 56 52C56 54.2091 54.2091 56 52 56C49.7909 56 48 54.2091 48 52Z",
    fill: "#169E8C"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M72 124C72 121.791 73.7909 120 76 120C78.2091 120 80 121.791 80 124C80 126.209 78.2091 128 76 128C73.7909 128 72 126.209 72 124Z",
    fill: "#169E8C"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M72 52C72 49.7909 73.7909 48 76 48C78.2091 48 80 49.7909 80 52C80 54.2091 78.2091 56 76 56C73.7909 56 72 54.2091 72 52Z",
    fill: "#169E8C"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M96 124C96 121.791 97.7909 120 100 120C102.209 120 104 121.791 104 124C104 126.209 102.209 128 100 128C97.7909 128 96 126.209 96 124Z",
    fill: "#169E8C"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M96 52C96 49.7909 97.7909 48 100 48C102.209 48 104 49.7909 104 52C104 54.2091 102.209 56 100 56C97.7909 56 96 54.2091 96 52Z",
    fill: "#169E8C"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M120 124C120 121.791 121.791 120 124 120C126.209 120 128 121.791 128 124C128 126.209 126.209 128 124 128C121.791 128 120 126.209 120 124Z",
    fill: "#169E8C"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M120 52C120 49.7909 121.791 48 124 48C126.209 48 128 49.7909 128 52C128 54.2091 126.209 56 124 56C121.791 56 120 54.2091 120 52Z",
    fill: "#169E8C"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M144 124C144 121.791 145.791 120 148 120C150.209 120 152 121.791 152 124C152 126.209 150.209 128 148 128C145.791 128 144 126.209 144 124Z",
    fill: "#169E8C"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M144 52C144 49.7909 145.791 48 148 48C150.209 48 152 49.7909 152 52C152 54.2091 150.209 56 148 56C145.791 56 144 54.2091 144 52Z",
    fill: "#169E8C"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M168 124C168 121.791 169.791 120 172 120C174.209 120 176 121.791 176 124C176 126.209 174.209 128 172 128C169.791 128 168 126.209 168 124Z",
    fill: "#169E8C"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M168 52C168 49.7909 169.791 48 172 48C174.209 48 176 49.7909 176 52C176 54.2091 174.209 56 172 56C169.791 56 168 54.2091 168 52Z",
    fill: "#169E8C"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M0 148C0 145.791 1.79086 144 4 144C6.20914 144 8 145.791 8 148C8 150.209 6.20914 152 4 152C1.79086 152 0 150.209 0 148Z",
    fill: "#169E8C"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M24 148C24 145.791 25.7909 144 28 144C30.2091 144 32 145.791 32 148C32 150.209 30.2091 152 28 152C25.7909 152 24 150.209 24 148Z",
    fill: "#169E8C"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M48 148C48 145.791 49.7909 144 52 144C54.2091 144 56 145.791 56 148C56 150.209 54.2091 152 52 152C49.7909 152 48 150.209 48 148Z",
    fill: "#169E8C"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M72 148C72 145.791 73.7909 144 76 144C78.2091 144 80 145.791 80 148C80 150.209 78.2091 152 76 152C73.7909 152 72 150.209 72 148Z",
    fill: "#169E8C"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M96 148C96 145.791 97.7909 144 100 144C102.209 144 104 145.791 104 148C104 150.209 102.209 152 100 152C97.7909 152 96 150.209 96 148Z",
    fill: "#169E8C"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M120 148C120 145.791 121.791 144 124 144C126.209 144 128 145.791 128 148C128 150.209 126.209 152 124 152C121.791 152 120 150.209 120 148Z",
    fill: "#169E8C"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M144 148C144 145.791 145.791 144 148 144C150.209 144 152 145.791 152 148C152 150.209 150.209 152 148 152C145.791 152 144 150.209 144 148Z",
    fill: "#169E8C"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M168 148C168 145.791 169.791 144 172 144C174.209 144 176 145.791 176 148C176 150.209 174.209 152 172 152C169.791 152 168 150.209 168 148Z",
    fill: "#169E8C"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M0 172C0 169.791 1.79086 168 4 168C6.20914 168 8 169.791 8 172C8 174.209 6.20914 176 4 176C1.79086 176 0 174.209 0 172Z",
    fill: "#169E8C"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M24 172C24 169.791 25.7909 168 28 168C30.2091 168 32 169.791 32 172C32 174.209 30.2091 176 28 176C25.7909 176 24 174.209 24 172Z",
    fill: "#169E8C"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M48 172C48 169.791 49.7909 168 52 168C54.2091 168 56 169.791 56 172C56 174.209 54.2091 176 52 176C49.7909 176 48 174.209 48 172Z",
    fill: "#169E8C"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M72 172C72 169.791 73.7909 168 76 168C78.2091 168 80 169.791 80 172C80 174.209 78.2091 176 76 176C73.7909 176 72 174.209 72 172Z",
    fill: "#169E8C"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M96 172C96 169.791 97.7909 168 100 168C102.209 168 104 169.791 104 172C104 174.209 102.209 176 100 176C97.7909 176 96 174.209 96 172Z",
    fill: "#169E8C"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M120 172C120 169.791 121.791 168 124 168C126.209 168 128 169.791 128 172C128 174.209 126.209 176 124 176C121.791 176 120 174.209 120 172Z",
    fill: "#169E8C"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M144 172C144 169.791 145.791 168 148 168C150.209 168 152 169.791 152 172C152 174.209 150.209 176 148 176C145.791 176 144 174.209 144 172Z",
    fill: "#169E8C"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M168 172C168 169.791 169.791 168 172 168C174.209 168 176 169.791 176 172C176 174.209 174.209 176 172 176C169.791 176 168 174.209 168 172Z",
    fill: "#169E8C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.16ba29588ed0ff069e61c329cde87968.svg";
export { ForwardRef as ReactComponent };